import { render, staticRenderFns } from "./ListDappView.vue?vue&type=template&id=c94db87a"
import script from "./ListDappView.vue?vue&type=script&lang=ts"
export * from "./ListDappView.vue?vue&type=script&lang=ts"
import style0 from "./ListDappView.vue?vue&type=style&index=0&id=c94db87a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports